import { useContext } from 'react'
import { RADashboardThemeContext } from '.'

export function useTheme() {
  const context = useContext(RADashboardThemeContext)
  return context.theme
}

export function useDarkModeCheck() {
  const context = useContext(RADashboardThemeContext)
  return context.isDarkMode
}

export function useThemeSettings() {
  const context = useContext(RADashboardThemeContext)
  return context
}
